/**
 * Saves text the browser built itself to the user's device as `fileName`: the content is wrapped in
 * a Blob and handed to a synthetic anchor click, so nothing leaves the device.
 *
 * Must run inside the click that asked for it — a browser may ignore a download it doesn't see as
 * user-initiated, and that failure is silent.
 */
export function downloadFile(content: string, fileName: string, mimeType: 'text/csv'): void {
  const url = URL.createObjectURL(new Blob([content], { type: `${mimeType};charset=utf-8` }));
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.rel = 'noopener';

  // The anchor has to be in the document for the synthetic click to start a download in Firefox.
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  // Revoking in the same task can cancel the download before WebKit has read the blob, which
  // matters because the portal also runs inside WKWebView. One macrotask is enough.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
